<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card title>
      <div class="mt-5">
        <div class="vx-row">
          <div class="vx-col md:w-1/1 w-full mt-5">
            <h6 class="mb-2">Tipo de Usuário</h6>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-5">
            <ul class="demo-alignment">
              <li>
                <vs-radio color="success" v-model="type" vs-value="copyjui"
                  >Copyjui</vs-radio
                >
              </li>
              <li>
                <vs-radio color="primary" v-model="type" vs-value="cliente"
                  >Cliente</vs-radio
                >
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5" v-show="type == 'cliente'">
            <div class="mt-4">
              <h6 class="mb-2">Cliente</h6>
              <v-select
                name="customer"
                v-model="customerSelected"
                :options="getCustomersFiltered"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
          </div>
        </div>
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mb-2">Nome</h6>
            <vs-input
              class="w-full mt-4"
              v-model="userName"
              name="name"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{
              errors.first("name")
            }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mb-2">Email</h6>
            <vs-input
              class="w-full mt-4"
              v-model="email"
              type="email"
              name="email"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full" v-show="type == 'copyjui'">
            <div class="mt-4">
              <h6 class="mb-2">Grupo</h6>
              <v-select
                v-model="group"
                :clearable="false"
                :options="optionsGroup"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
          </div>
          <div
            class="vx-col md:w-1/2 w-full"
            v-show="group == 'admin' && type == 'copyjui'"
          >
            <div class="mt-4">
              <h6 class="mb-2">Equipamentos Visiveis</h6>
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    color="success"
                    v-model="equipmentIsVisible"
                    vs-value="1"
                    >Sim</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    color="#1E90FF"
                    v-model="equipmentIsVisible"
                    vs-value="0"
                    >Não</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mb-2">Senha</h6>
            <vs-input
              name="password1"
              class="w-full mt-4"
              v-model="password1"
              type="password"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('password1')"
              >{{ errors.first("password1") }}</span
            >
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mb-2">Confirmar Senha</h6>
            <vs-input
              name="password2"
              class="w-full mt-4"
              v-model="password2"
              type="password"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('password2')"
              >{{ errors.first("password2") }}</span
            >
          </div>
        </div>
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/1 w-full">
            <vs-button class="float-right" @click="submit">Salvar</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { baseApiUrl } from "@/global";
import { Validator } from "vee-validate";
import axios from "axios";
import * as lang from "vuejs-datepicker/src/locale";
import router from "@/router";
import { momentJS } from "@/helpers";
const dict = {
  custom: {
    name: {
      required: "Por favor insira nome",
      alpha: "Your first name may only contain alphabetic characters",
    },
    email: {
      required: "Por favor insira o email",
      alpha: "Your first name may only contain alphabetic characters",
    },
    password1: {
      required: "Por favor insira a senha",
      alpha: "Your first name may only contain alphabetic characters",
    },
    password2: {
      required: "Por favor confirme a senha",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: {
    vSelect,
  },
  props: {},
  data() {
    return {
      languages: lang,
      userName: null,
      email: null,
      type: "copyjui",
      customerSelected: [],
      group: "admin",
      optionsGroup: ["admin", "funcionario"],
      password1: null,
      password2: null,
      equipmentIsVisible: 0,
    };
  },
  computed: {
    getCustomersFiltered() {
      return this.$store.state.customers.customersFiltered;
    },
  },
  methods: {
    async submit() {
      const haveErrors = !(await this.$validator.validateAll());
      console.log(haveErrors);
      if (haveErrors) return;
      if (this.group == "funcionario") {
        this.equipmentIsVisible = 1;
      }
      let response;
      try {
        this.$vs.loading();
        let user = {
          userName: this.userName,
          password1: this.password1,
          password2: this.password2,
          email: this.email,
          userGroup: this.group,
          equipmentIsVisible: this.equipmentIsVisible,
          type: this.type,
          lastLogin: momentJS().getDateTime(),
          fk_idCustomer: this.customerSelected.id,
        };
        response = await axios.post(`${baseApiUrl}/user/addNewUser`, user);
        this.$vs.notify({
          title: "Criado",
          text: "Com Sucesso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        if (response.status == "200") {
          router.push(`/usuarios`).catch(() => {});
        }
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Erro",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
        if (error.response.status == "400") {
          router.push(`/usuarios`).catch(() => {});
        }
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    let payload = {
      loading: this.$vs.loading,
    };
    this.$store.dispatch("customers/fetchCustomersItems", payload);
  },
};
</script>
